"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditorAnnouncementModal_1 = require("./EditorAnnouncementModal");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return EditorAnnouncementModal_1.default; } });
